// extracted by mini-css-extract-plugin
export default {"controls":"BaseCounter_controls__a9D15","button":"BaseCounter_button__1LSi9","buttonDisabled":"BaseCounter_buttonDisabled__14D58","count":"BaseCounter_count__LK-BA"};